var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { alpha, Badge, Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tab, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { Add01Icon, BubbleChatIcon, Delete02Icon, Edit02Icon, FileDownloadIcon, FileViewIcon, Link05Icon, MoreVerticalCircle01Icon, SquareLock01Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import * as pdfJs from 'pdfjs-dist';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useSetDocumentFilterMutation } from '../../../application/features/chat/chat-api';
import { DocumentProcessingStatus } from '../../../application/features/machine-documents/enums/document-processing-status';
import { MachineDocumentUploadingStatus } from '../../../application/features/machine-documents/enums/machine-document-uploading-status';
import { useDeleteMachineDocumentMutation, useGetPaginatedMachineDocumentsQuery, useRetryDocumentsProcessingMutation } from '../../../application/features/machine-documents/machine-document-api';
import { useGetActiveMachinesWithModelsQuery, useLazyGetAllByDocumentQuery } from '../../../application/features/machines/machine-api';
import { graphApi } from '../../../application/features/microsoft-graph/microsoft-graph-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import ConfirmDialog from '../../components/ConfirmDialog';
import DocumentStatusTag from '../../components/DocumentStatusTag';
import FilterButton from '../../components/FilterButton';
import Loader from '../../components/loader';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import { usePermissionGranted } from '../../hooks/usePermissionGranted';
import AiMagicIcon from '../../icons/ai-magic';
import { Permissions } from '../../permissions';
import AddDocument from './add-document';
import AiSummaryDrawer from './ai-summary-drawer';
import ArchivedTab from './archived-tab';
import DeleteDocumentDialog from './delete-document-dialog';
import KnowledgeCards from './knowledge-cards';
import KnowledgeDatagrid from './knowledge-datagrid';
import NewTab from './new-tab';
import './style.scss';
import UpdateDocument from './update-document';
import ViewDocument from './view-document';
var CHAT_START_LOCATION = 'Knowledge';
var MACHINE_ENDPOINT = process.env.REACT_APP_CHAT_MACHINE_ENDPOINT;
pdfJs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(pdfJs.version, "/build/pdf.worker.min.mjs");
var Knowledge = function () {
    var _a;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var navigate = useNavigate();
    var _c = __read(useSearchParams(), 1), searchParams = _c[0];
    var id = searchParams.get('id');
    var lastProcessedMachineIdRef = useRef(null);
    var lastProcessedModelNumberRef = useRef(null);
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var hasCreatePermission = usePermissionGranted({ permissions: [Permissions.Knowledge.Create] });
    var newDocumentsCount = useAppSelector(function (state) { return state.machineDocument; }).newDocumentsCount;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isScreen329px = useMediaQuery('(min-width:327px) and (max-width:368px');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:901px) and (max-width:1201px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var _d = __read(useState(null), 2), openTooltipId = _d[0], setOpenTooltipId = _d[1];
    var _e = __read(useState(false), 2), openFilterDrawer = _e[0], setOpenFilterDrawer = _e[1];
    var _f = __read(useState(null), 2), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = __read(useState([]), 2), selectedMachineModels = _g[0], setSelectedMachineModels = _g[1];
    var _h = __read(useState([]), 2), selectedMachinesForDeletion = _h[0], setSelectedMachinesForDeletion = _h[1];
    var _j = __read(useState(null), 2), menuRowId = _j[0], setMenuRowId = _j[1];
    var _k = __read(useState(false), 2), aiSummaryDrawerOpen = _k[0], setAiSummaryDrawerOpen = _k[1];
    var _l = __read(useState(undefined), 2), selectedDocument = _l[0], setSelectedDocument = _l[1];
    var _m = __read(useState(false), 2), addDocumentModalOpen = _m[0], setAddDocumentModalOpen = _m[1];
    var _o = __read(useState([]), 2), selectedDocuments = _o[0], setSelectedDocuments = _o[1];
    var _p = __read(useState('Approved'), 2), tabValue = _p[0], setTabValue = _p[1];
    var _q = __read(useState([]), 2), initialFiles = _q[0], setInitialFiles = _q[1];
    var _r = __read(useState(false), 2), isUploadingFiles = _r[0], setIsUploadingFiles = _r[1];
    var _s = __read(useState({ isOpen: false }), 2), updateDocument = _s[0], setUpdateDocument = _s[1];
    var _t = __read(useState({ isOpen: false }), 2), deleteDocument = _t[0], setDeleteDocument = _t[1];
    var _u = __read(useState({ isOpen: false }), 2), viewDocument = _u[0], setViewDocument = _u[1];
    var _v = __read(useState({
        fileName: '',
        machineModels: [],
        processingStatus: undefined,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), machineDocumentFilters = _v[0], setMachineDocumentFilters = _v[1];
    var chatApiStatus = useAppSelector(function (state) { return state.common; }).chatApiStatus;
    var _w = __read(useLazyGetAllByDocumentQuery(), 2), getMachine = _w[0], _x = _w[1], machinesByDocument = _x.data, isMachineLoading = _x.isLoading;
    var _y = __read(useDeleteMachineDocumentMutation(), 2), deleteMachineDocument = _y[0], _z = _y[1], deleteDocumentSuccess = _z.isSuccess, deleteDocumentLoading = _z.isLoading;
    var _0 = useGetActiveMachinesWithModelsQuery({
        companyId: isSuperAdmin ? undefined : currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id,
        filterByCompany: true
    }), _1 = _0.data, machinesWithModels = _1 === void 0 ? [] : _1, machinesFetching = _0.isLoading;
    var _2 = __read(useRetryDocumentsProcessingMutation(), 2), retryProcessing = _2[0], _3 = _2[1], retryProcessingLoading = _3.isLoading, retryProcessingSuccess = _3.isSuccess;
    var _4 = useGetPaginatedMachineDocumentsQuery(machineDocumentFilters, {
        refetchOnMountOrArgChange: true
    }), data = _4.data, isFetching = _4.isFetching;
    var _5 = __read(useSetDocumentFilterMutation(), 2), setDocumentsFilter = _5[0], documentFilterLoading = _5[1].isLoading;
    var _6 = (data !== null && data !== void 0 ? data : {}).items, machineDocuments = _6 === void 0 ? [] : _6;
    var statusOptions = [
        {
            label: translate('knowledge.processing'),
            value: DocumentProcessingStatus.NotProcessed
        },
        {
            label: translate('knowledge.processingComplete'),
            value: DocumentProcessingStatus.Success
        },
        {
            label: translate('knowledge.processingFailed'),
            value: DocumentProcessingStatus.RetryableFailure
        },
        {
            label: translate('knowledge.unprocessable'),
            value: DocumentProcessingStatus.NonRetryableFailure
        }
    ];
    var processDocuments = !MACHINE_ENDPOINT || chatApiStatus === 'ok';
    var _7 = useForm({
        defaultValues: {
            fileName: '',
            machineModels: []
        }
    }), control = _7.control, handleSubmit = _7.handleSubmit, setValue = _7.setValue, getValues = _7.getValues, reset = _7.reset, errors = _7.formState.errors;
    useEffect(function () {
        if (retryProcessingSuccess)
            enqueueSnackbar({
                variant: 'success',
                message: translate('knowledge.retryProcessingStarted'),
                autoHideDuration: 3000,
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [retryProcessingSuccess]);
    useEffect(function () {
        var machineId = searchParams.get('machine-id');
        var modelNumber = searchParams.get('model-number');
        var paramsKey = "".concat(machineId, "-").concat(modelNumber);
        // Only process if machine-id or model-number has changed
        if (machineId &&
            paramsKey !== "".concat(lastProcessedMachineIdRef.current, "-").concat(lastProcessedModelNumberRef.current)) {
            var machine = machinesWithModels.find(function (m) { return m.id === machineId; });
            if (machine) {
                lastProcessedMachineIdRef.current = machineId;
                lastProcessedModelNumberRef.current = modelNumber;
                // If model-number is specified, filter to that specific model, otherwise use all models
                var modelNumbers_1 = modelNumber
                    ? machine.models
                        .filter(function (m) { return m.modelNumber === modelNumber; })
                        .map(function (m) { return m.modelNumber; })
                    : machine.models.map(function (m) { return m.modelNumber; });
                setSelectedMachineModels([
                    {
                        machineId: machine.id,
                        modelNumbers: modelNumbers_1
                    }
                ]);
                setValue('machineModels', [{ machineId: machineId, modelNumbers: modelNumbers_1 }]);
                setMachineDocumentFilters(function (filters) { return (__assign(__assign({}, filters), { machineModels: [
                        {
                            machineId: machineId,
                            modelNumbers: modelNumbers_1
                        }
                    ] })); });
            }
        }
        else if (!machineId &&
            (lastProcessedMachineIdRef.current || lastProcessedModelNumberRef.current)) {
            // Clear the refs when machine-id is removed from URL
            lastProcessedMachineIdRef.current = null;
            lastProcessedModelNumberRef.current = null;
        }
        var documentId = searchParams.get('document-id');
        if (documentId) {
            setMachineDocumentFilters(function (filters) { return (__assign(__assign({}, filters), { id: documentId })); });
        }
    }, [searchParams, machinesWithModels, setValue]);
    useEffect(function () {
        if (id) {
            var documentId_1 = searchParams.get('id');
            if (documentId_1)
                setMachineDocumentFilters(function (filters) {
                    return __assign(__assign({}, filters), { id: documentId_1 });
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, setValue]);
    useMemo(function () {
        if (currentCompany) {
            setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { fileName: '', machineModels: [] })); });
            setSelectedMachineModels([]);
            setSelectedMachinesForDeletion([]);
        }
    }, [currentCompany]);
    useEffect(function () {
        if (deleteDocumentSuccess)
            enqueueSnackbar(tWithField('toolTips.deleteSuccess', 'common.document'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteDocumentSuccess]);
    var rowCountRef = React.useRef((_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var handlePaginationModelChange = function (model) {
        setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setMachineDocumentFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setMachineDocumentFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _8 = __read(useState({
        items: []
    }), 2), filterModel = _8[0], setFilterModel = _8[1];
    var _9 = __read(useState(false), 2), deleteDocumentOpen = _9[0], setDeleteDocumentOpen = _9[1];
    var handleOpen = function () { return setDeleteDocumentOpen(true); };
    var handleClose = function () {
        setDeleteDocumentOpen(false);
        setSelectedMachinesForDeletion([]);
    };
    var handleTabChange = function (_event, newValue) {
        setTabValue(newValue);
        if (newValue === 'Approved') {
            setMachineDocumentFilters({
                fileName: '',
                machineModels: [],
                processingStatus: undefined,
                sortField: AppConsts.DEFAULT_SORT_FIELD,
                sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
                page: AppConsts.DEFAULT_PAGE_NUMBER,
                pageSize: AppConsts.DEFAULT_PAGE_SIZE,
                filterField: undefined,
                filterOperator: undefined,
                filterValue: undefined
            });
            setSelectedMachineModels([]);
            setFilterModel({ items: [] });
            reset({ fileName: '', machineModels: [] });
        }
    };
    var handleDelete = function () {
        var machines = selectedMachinesForDeletion.length > 1 ? selectedMachinesForDeletion : [];
        deleteMachineDocument({ id: deleteDocument.id, machines: machines });
        handleClose();
        setDeleteDocument({ id: undefined, isOpen: false });
    };
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var handleAddDocument = function () { return setAddDocumentModalOpen(true); };
    var validatePDF = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var arrayBuffer, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 1:
                    arrayBuffer = _b.sent();
                    return [4 /*yield*/, pdfJs.getDocument({ data: arrayBuffer }).promise];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleFileUpload = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var fileArray, validFileObjects, invalidFiles, maxFileSize, oversizedFiles, validFiles, uncorruptedFiles, corruptedFileNames, validFiles_1, validFiles_1_1, file, isValid, e_1_1, errorMessage;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Check permission before processing files
                    if (!hasCreatePermission) {
                        return [2 /*return*/];
                    }
                    setIsUploadingFiles(true);
                    fileArray = [];
                    if (files instanceof FileList) {
                        fileArray = Array.from(files);
                    }
                    else if (Array.isArray(files)) {
                        fileArray = files;
                    }
                    else {
                        fileArray = [files];
                    }
                    validFileObjects = fileArray.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.name) && (file === null || file === void 0 ? void 0 : file.size) !== undefined; });
                    if (validFileObjects.length === 0) {
                        setIsUploadingFiles(false);
                        return [2 /*return*/];
                    }
                    invalidFiles = validFileObjects.filter(function (file) {
                        var fileType = file.type || '';
                        var fileName = file.name || '';
                        return !fileType.toLowerCase().includes('pdf') && !fileName.toLowerCase().endsWith('.pdf');
                    });
                    if (invalidFiles.length > 0) {
                        enqueueSnackbar({
                            variant: 'error',
                            message: translate('fileUpload.fileTypeError', { field: 'PDF' }),
                            autoHideDuration: 3000,
                            anchorOrigin: { horizontal: 'right', vertical: 'top' }
                        });
                        setIsUploadingFiles(false);
                        return [2 /*return*/];
                    }
                    maxFileSize = 100 * 1024 * 1024;
                    oversizedFiles = validFileObjects.filter(function (file) { return file.size > maxFileSize; });
                    validFiles = validFileObjects.filter(function (file) { return file.size <= maxFileSize; });
                    // If only one file and it's oversized, show error and stop
                    if (validFileObjects.length === 1 && oversizedFiles.length === 1) {
                        enqueueSnackbar({
                            variant: 'error',
                            message: translate('fileUpload.fileSizeError', {
                                count: 100
                            }),
                            autoHideDuration: 3000,
                            anchorOrigin: { horizontal: 'right', vertical: 'top' }
                        });
                        setIsUploadingFiles(false);
                        return [2 /*return*/];
                    }
                    // If multiple files, show warning if some files were removed
                    if (oversizedFiles.length > 0) {
                        enqueueSnackbar({
                            variant: 'warning',
                            message: translate('fileUpload.oversizedFilesRemoved', {
                                count: oversizedFiles.length
                            }),
                            autoHideDuration: 5000,
                            anchorOrigin: { horizontal: 'right', vertical: 'top' }
                        });
                    }
                    // If no valid files remain after filtering, stop here
                    if (validFiles.length === 0) {
                        setIsUploadingFiles(false);
                        return [2 /*return*/];
                    }
                    uncorruptedFiles = [];
                    corruptedFileNames = [];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    validFiles_1 = __values(validFiles), validFiles_1_1 = validFiles_1.next();
                    _b.label = 2;
                case 2:
                    if (!!validFiles_1_1.done) return [3 /*break*/, 5];
                    file = validFiles_1_1.value;
                    return [4 /*yield*/, validatePDF(file)];
                case 3:
                    isValid = _b.sent();
                    if (!isValid) {
                        corruptedFileNames.push(file.name);
                    }
                    else {
                        uncorruptedFiles.push(file);
                    }
                    _b.label = 4;
                case 4:
                    validFiles_1_1 = validFiles_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (validFiles_1_1 && !validFiles_1_1.done && (_a = validFiles_1.return)) _a.call(validFiles_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8:
                    // Show errors for corrupted files
                    if (corruptedFileNames.length > 0) {
                        errorMessage = corruptedFileNames.length === 1
                            ? tWithField('fileUpload.corruptedFileError', corruptedFileNames[0])
                            : "".concat(translate('fileUpload.corruptedFilesError'), ": ").concat(corruptedFileNames.join(', '));
                        enqueueSnackbar({
                            variant: 'error',
                            message: errorMessage,
                            autoHideDuration: 5000,
                            anchorOrigin: { horizontal: 'right', vertical: 'top' }
                        });
                    }
                    // If no valid files remain after corruption check, stop here
                    if (uncorruptedFiles.length === 0) {
                        setIsUploadingFiles(false);
                        return [2 /*return*/];
                    }
                    // Proceed with valid, uncorrupted files only
                    setInitialFiles(uncorruptedFiles);
                    setAddDocumentModalOpen(true);
                    setIsUploadingFiles(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMenuClick = function (event, rowId) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(rowId);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(null);
    };
    var filterDocuments = function () {
        setMachineDocumentFilters(__assign(__assign({}, machineDocumentFilters), { fileName: getValues('fileName'), processingStatus: getValues('processingStatus'), machineModels: selectedMachineModels }));
    };
    var onDeleteDocument = function (documentId, isPublic) {
        setAnchorEl(null);
        setMenuRowId(null);
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin && isPublic) {
            getMachine({ documentId: documentId });
            handleOpen();
            setDeleteDocument({ isOpen: false, id: documentId });
        }
        else {
            setDeleteDocument({ isOpen: true, id: documentId });
        }
    };
    var onDeleteConfirm = function () {
        deleteMachineDocument({ id: deleteDocument.id, machines: [] });
        setDeleteDocument({ id: undefined, isOpen: false });
    };
    var onEditDocument = function (document) {
        setUpdateDocument({
            id: document.id,
            isOpen: true
        });
        setAnchorEl(null);
        setMenuRowId(null);
    };
    var onViewDocument = function (document) {
        setAnchorEl(null);
        setMenuRowId(null);
        setViewDocument({ isOpen: true, document: document });
    };
    var onDownloadDocument = function (machineDocument) { return __awaiter(void 0, void 0, void 0, function () {
        var downloadUrl, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAnchorEl(null);
                    setMenuRowId(null);
                    return [4 /*yield*/, graphApi.getDownloadUrl(machineDocument.filePath)];
                case 1:
                    downloadUrl = _a.sent();
                    link = document.createElement('a');
                    link.href = downloadUrl;
                    link.click();
                    link.remove();
                    return [2 /*return*/];
            }
        });
    }); };
    var onViewAISummary = function (document) {
        setSelectedDocument(document);
        setAnchorEl(null);
        setMenuRowId(null);
        setAiSummaryDrawerOpen(true);
    };
    var onSelectionChange = function (selected) {
        var selectedRowsData = machineDocuments.filter(function (document) { return selected.ids.has(document.id); });
        setSelectedDocuments(selectedRowsData);
    };
    var getRowSelectable = function (params) {
        if (!params.row)
            return false;
        if (params.row.addedToKnowledgeBase && selectedDocuments.length === 0)
            return true;
        var machines = selectedDocuments.map(function (document) { return document.machineId; });
        return params.row.addedToKnowledgeBase && machines.includes(params.row.machineId);
    };
    var startDocumentsChat = function () { return __awaiter(void 0, void 0, void 0, function () {
        var documents, conversation_id, documentsFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    documents = selectedDocuments.map(function (document) { return document.id; });
                    conversation_id = nanoid();
                    documentsFilter = {
                        conversation_id: conversation_id,
                        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                        user_name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
                        chat_start_location: CHAT_START_LOCATION,
                        documents: documents,
                        company_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id
                    };
                    return [4 /*yield*/, setDocumentsFilter(documentsFilter).unwrap()];
                case 1:
                    _a.sent();
                    navigate('/chats');
                    return [2 /*return*/];
            }
        });
    }); };
    var startDocumentChat = function (document) { return __awaiter(void 0, void 0, void 0, function () {
        var conversation_id, documentsFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAnchorEl(null);
                    setMenuRowId(null);
                    conversation_id = nanoid();
                    documentsFilter = {
                        conversation_id: conversation_id,
                        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                        user_name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
                        documents: [document.id],
                        chat_start_location: CHAT_START_LOCATION,
                        company_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id
                    };
                    return [4 /*yield*/, setDocumentsFilter(documentsFilter).unwrap()];
                case 1:
                    _a.sent();
                    navigate('/chats');
                    return [2 /*return*/];
            }
        });
    }); };
    var machinesColumns = [
        {
            field: 'linked',
            headerName: translate('knowledge.linked'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.4 : 0.4,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: false,
            sortable: false,
            disableColumnMenu: true,
            headerAlign: 'center',
            renderHeader: function () { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: _jsx(Link05Icon, { width: 24, height: 24 }) })); },
            renderCell: function (params) {
                return (_jsx(_Fragment, { children: params.row.linkedFromMachineDocumentId && (_jsx(Box, { display: 'flex', flexShrink: 0, alignItems: 'center', justifyContent: 'center', height: '100%', sx: { cursor: 'pointer' }, children: _jsx(Tooltip, { arrow: true, placement: 'right', open: openTooltipId === params.row.id, onOpen: function () { return setOpenTooltipId(params.row.id); }, onClose: function () { return setOpenTooltipId(null); }, slotProps: {
                                popper: { disablePortal: false }
                            }, title: _jsx(Box, { maxHeight: '150px', sx: { overflowY: 'auto' }, children: _jsx(Box, { sx: {
                                        p: 1,
                                        color: 'white',
                                        minWidth: 180
                                    }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px' }, children: [_jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('common.asset') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: params.row.linkedFromMachineName })] }), isSuperAdmin && (_jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('common.company') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: params.row.linkedFromCompanyName })] })), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('assets.matchingAssets.model') + '#:' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: params.row.linkedFromModelNumber })] })] }) }) }), children: _jsx(Link05Icon, { width: 24, height: 24 }) }) })) }));
            }
        },
        {
            field: 'private',
            headerName: translate('knowledge.private'),
            headerAlign: 'center',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: false,
            sortable: false,
            disableColumnMenu: true,
            renderHeader: function () { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: _jsx(SquareLock01Icon, { width: 24, height: 24 }) })); },
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, marginTop: '14px', children: !params.row.isPublic && _jsx(SquareLock01Icon, { width: 24, height: 24 }) })); }
        },
        {
            field: 'title',
            headerName: translate('knowledge.title'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            filterable: true,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 2, my: params.row.addedToKnowledgeBase ? '15px' : '5px', children: _jsxs(Box, { display: 'flex', flexDirection: 'column', sx: {
                        width: '100%',
                        overflow: 'hidden'
                    }, children: [_jsx(Box, { display: 'flex', gap: 0.5, alignItems: 'center', children: _jsx(Typography, { title: params.row.title, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', sx: { color: theme.palette.text.primary }, children: params.row.title }) }), _jsx(DocumentStatusTag, { uploadingStatus: params.row.uploadingStatus, processingStatus: params.row.processingStatus, addedToKnowledgeBase: params.row.addedToKnowledgeBase })] }) })); }
        },
        {
            field: 'fileName',
            headerName: translate('knowledge.documentTitle'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 300 : isscreen600900 ? 300 : isMd ? 300 : undefined,
            width: isXs ? 300 : isMd ? 300 : isscreen600900 ? 300 : undefined,
            filterable: true,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, my: 1.7, onClick: function () { return onViewDocument(params.row); }, sx: { cursor: 'pointer' }, children: _jsx(Typography, { title: params.row.fileName, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: params.row.fileName }) })); }
        },
        {
            field: 'createdByName',
            headerName: translate('knowledge.createdBy'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: true,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'machineName',
            headerName: translate('common.asset'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: true,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, marginTop: params.row.modelNumber ? '4.5px' : '14px', children: _jsxs(Box, { display: 'flex', justifyContent: 'center', flexDirection: 'column', flex: 1, minWidth: 0, children: [_jsx(Typography, { variant: 'body2', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', children: params.row.machineName }), params.row.modelNumber ? (_jsx(Typography, { variant: 'body2', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', sx: { color: theme.palette.text.secondary }, children: params.row.modelNumber })) : (_jsx(_Fragment, {}))] }) })); }
        },
        {
            field: 'action',
            headerName: '',
            align: 'right',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.1 : 0.1,
            width: isXs ? 1 : isMd ? 1 : isscreen600900 ? 1 : undefined,
            renderCell: function (params) {
                return (_jsxs(Fragment, { children: [_jsx(IconButton, { size: 'medium', onClick: function (event) { return handleMenuClick(event, params.id); }, children: _jsx(MoreVerticalCircle01Icon, { width: 20, height: 20 }) }), _jsxs(Menu, { anchorEl: anchorEl, open: menuRowId === params.id, onClose: handleMenuClose, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'center'
                            }, children: [_jsx(ProtectedElement, { permissions: [Permissions.Knowledge.Update], children: _jsxs(MenuItem, { disabled: !params.row.addedToKnowledgeBase, onClick: function () { return onEditDocument(params.row); }, children: [_jsx(ListItemIcon, { children: _jsx(Edit02Icon, { fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('actions.edit') })] }) }), _jsx(Divider, {}), _jsxs(MenuItem, { disabled: !params.row.addedToKnowledgeBase, onClick: function () { return startDocumentChat(params.row); }, children: [_jsx(ListItemIcon, { children: _jsx(BubbleChatIcon, { fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('knowledge.startChat') })] }), _jsxs(MenuItem, { disabled: !params.row.addedToKnowledgeBase, onClick: function () {
                                        onViewAISummary(params.row);
                                    }, children: [_jsx(ListItemIcon, { children: _jsx(AiMagicIcon, { fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('knowledge.aiSummary') })] }), _jsxs(MenuItem, { disabled: params.row.uploadingStatus !== MachineDocumentUploadingStatus.Success, onClick: function () {
                                        onViewDocument(params.row);
                                    }, children: [_jsx(ListItemIcon, { children: _jsx(FileViewIcon, { size: 24 }) }), _jsx(ListItemText, { children: translate('knowledge.viewDocument') })] }), _jsxs(MenuItem, { disabled: !params.row.isDownloadable, onClick: function () {
                                        onDownloadDocument(params.row);
                                    }, children: [_jsx(ListItemIcon, { children: _jsx(FileDownloadIcon, { size: 24 }) }), _jsx(ListItemText, { children: translate('knowledge.downloadDocument') })] }), _jsx(Divider, {}), _jsx(ProtectedElement, { permissions: [Permissions.Knowledge.Delete], children: _jsxs(MenuItem, { disabled: deleteDocumentLoading, onClick: function () { return onDeleteDocument(params.row.id, params.row.isPublic); }, sx: { color: theme.palette.error.main }, children: [_jsx(ListItemIcon, { sx: { color: 'inherit' }, children: _jsx(Delete02Icon, { color: 'inherit', fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('actions.delete') })] }) })] })] }));
            }
        }
    ];
    return (_jsxs(Box, { sx: {
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [isUploadingFiles && _jsx(Loader, { open: isUploadingFiles }), _jsxs(Box, { display: 'flex', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', alignItems: 'center', mb: { xs: 0, md: 0, lg: 2 }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isScreen329px ? 'h6' : isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.knowledge') }), _jsx(ProtectedElement, { permissions: [Permissions.Knowledge.Create], children: _jsx(PageHeaderButton, { disabled: !processDocuments, text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleAddDocument, variant: 'contained', color: 'primary', title: translate('knowledge.addToKnowledgeBase') }) }), _jsx(PageHeaderButton, { onClick: retryProcessing, disabled: retryProcessingLoading || !processDocuments, text: isXs ? translate('knowledge.retry') : translate('knowledge.retryProcessing'), icon: _jsx(Icon, { icon: 'mdi:reload', fontSize: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', variant: 'outlined', color: 'primary', title: translate('knowledge.retryProcessing') })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), _jsxs(Box, { sx: { width: '100%' }, children: [hasCreatePermission ? (_jsx(FileUploader, { multiple: true, types: ['PDF'], required: true, handleChange: handleFileUpload, onTypeError: function () {
                            enqueueSnackbar({
                                variant: 'error',
                                message: translate('fileUpload.fileTypeError', { field: 'PDF' }),
                                autoHideDuration: 3000,
                                anchorOrigin: { horizontal: 'right', vertical: 'top' }
                            });
                        }, children: _jsx(Box, { mt: isXs || isIpadMini || isscreen600900 || iscreen9001200 ? 2 : 0, borderRadius: 1, border: "1px solid ".concat(alpha(theme.palette.divider, 0.2)), padding: theme.spacing(5), gap: theme.spacing(3), bgcolor: alpha(theme.palette.grey[500], 0.08), sx: { cursor: 'pointer' }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: theme.spacing(1), justifyContent: 'center', alignItems: 'center', textAlign: 'center', children: [_jsx(Typography, { variant: 'h6', children: translate('knowledge.uploadFilesDialog.uploadKnowledgeDocuments') }), _jsxs(Typography, { variant: 'body2', color: 'text.secondary', children: [isSm || isXs
                                                ? translate('knowledge.uploadFilesDialog.browseText')
                                                : translate('knowledge.uploadFilesDialog.dropFilesText'), ' ', _jsx("span", { style: { color: theme.palette.primary.main }, children: translate('knowledge.uploadFilesDialog.browse') }), ' ', translate('knowledge.uploadFilesDialog.throughYourMachine')] })] }) }) })) : (_jsx(Box, { mt: isXs || isIpadMini || isscreen600900 || iscreen9001200 ? 2 : 0, borderRadius: 1, border: "1px solid ".concat(alpha(theme.palette.divider, 0.2)), padding: theme.spacing(5), gap: theme.spacing(3), bgcolor: alpha(theme.palette.grey[500], 0.08), sx: { cursor: 'not-allowed', opacity: 0.6 }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: theme.spacing(1), justifyContent: 'center', alignItems: 'center', textAlign: 'center', children: [_jsx(Typography, { variant: 'h6', children: translate('knowledge.uploadFilesDialog.uploadKnowledgeDocuments') }), _jsxs(Typography, { variant: 'body2', color: 'text.secondary', children: [isSm || isXs
                                            ? translate('knowledge.uploadFilesDialog.browseText')
                                            : translate('knowledge.uploadFilesDialog.dropFilesText'), ' ', _jsx("span", { style: { color: theme.palette.primary.main }, children: translate('knowledge.uploadFilesDialog.browse') }), ' ', translate('knowledge.uploadFilesDialog.throughYourMachine')] })] }) })), _jsxs(TabContext, { value: tabValue, children: [!isSuperAdmin && (_jsx(Box, { sx: {
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'flex-start',
                                    marginLeft: isXs ? '0px' : '13px'
                                }, children: _jsxs(TabList, { onChange: handleTabChange, "aria-label": 'Assets tabs', variant: 'scrollable', children: [_jsx(Tab, { iconPosition: 'start', label: translate('knowledge.approved'), value: 'Approved' }), _jsx(Tab, { value: 'New', label: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [translate('knowledge.new'), _jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', children: !isSuperAdmin && newDocumentsCount !== undefined && (_jsx(Badge, { variant: 'standard', color: 'default', max: Infinity, sx: { bgcolor: '#DFE3E8', px: '6px', borderRadius: '500px' }, children: _jsx(Typography, { fontWeight: 700, fontSize: '12px', color: '161C24', textAlign: 'center', children: newDocumentsCount }) })) })] }) }), _jsx(Tab, { iconPosition: 'start', label: translate('knowledge.archived'), value: 'Archived' })] }) })), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Approved', sx: { padding: isXs ? '0px' : '6px' }, children: isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(KnowledgeCards, { deleteDocumentLoading: deleteDocumentLoading, documentFilterLoading: documentFilterLoading, control: control, handleSubmit: handleSubmit, reset: reset, errors: errors, machineDocumentFilters: machineDocumentFilters, setMachineDocumentFilters: setMachineDocumentFilters, documents: machineDocuments, statusOptions: statusOptions, isFetching: isFetching, machinesFetching: machinesFetching, machinesWithModels: machinesWithModels, selectedDocument: selectedDocument, setSelectedDocument: setSelectedDocument, selectedDocuments: selectedDocuments, setSelectedDocuments: setSelectedDocuments, selectedMachineModels: selectedMachineModels, setSelectedMachineModels: setSelectedMachineModels, filterDocuments: filterDocuments, onViewDocument: onViewDocument, onDownloadDocument: onDownloadDocument, onViewAiSummary: onViewAISummary, startDocumentChat: startDocumentChat, startDocumentsChat: startDocumentsChat, onEditDocument: onEditDocument, onDeleteDocument: onDeleteDocument, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape })) : (_jsx(KnowledgeDatagrid, { control: control, handleSubmit: handleSubmit, reset: reset, machineDocumentFilters: machineDocumentFilters, setMachineDocumentFilters: setMachineDocumentFilters, errors: errors, filterDocuments: filterDocuments, statusOptions: statusOptions, isFetching: isFetching, documentFilterLoading: documentFilterLoading, machinesFetching: machinesFetching, machinesWithModels: machinesWithModels, selectedMachineModels: selectedMachineModels, setSelectedMachineModels: setSelectedMachineModels, selectedDocuments: selectedDocuments, selectedDocumentsCount: selectedDocuments.length, rows: machineDocuments, columns: machinesColumns, rowCount: rowCount, paginationModel: {
                                            page: machineDocumentFilters.page - 1,
                                            pageSize: machineDocumentFilters.pageSize
                                        }, onPaginationModelChange: handlePaginationModelChange, onSortModelChange: handleSortModelChange, onSelectionChange: onSelectionChange, onFilterModelChange: handleFilterModelChange, filterModel: filterModel, getRowSelectable: getRowSelectable, onStartDocumentsChat: startDocumentsChat, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, isXs: isXs, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen9001200Landscape: isscreen9001200Landscape })) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'New', sx: { padding: isXs ? '0px' : '6px' }, children: _jsx(NewTab, { isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isSm: isSm, isMd: isMd, isLg: isLg, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer }) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Archived', sx: { padding: isXs ? '0px' : '6px' }, children: _jsx(ArchivedTab, { isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isSm: isSm, isMd: isMd, isLg: isLg, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer }) }) })] })] }), _jsx(AiSummaryDrawer, { open: aiSummaryDrawerOpen, onClose: function () { return setAiSummaryDrawerOpen(false); }, document: selectedDocument }), addDocumentModalOpen && (_jsx(AddDocument, { onClose: function () {
                    setAddDocumentModalOpen(false);
                    setInitialFiles([]);
                }, open: addDocumentModalOpen, initialFiles: initialFiles })), updateDocument.isOpen && (_jsx(UpdateDocument, { documentId: updateDocument.id, open: updateDocument.isOpen, onClose: function () { return setUpdateDocument({ isOpen: false }); } })), viewDocument.document && (_jsx(ViewDocument, { documentId: viewDocument.document.id, filePath: viewDocument.document.filePath, title: viewDocument.document.title, open: viewDocument.isOpen, onClose: function () { return setViewDocument({ isOpen: false }); } })), _jsx(ConfirmDialog, { open: deleteDocument.isOpen, onClose: function () { return setDeleteDocument({ isOpen: false }); }, onConfirm: onDeleteConfirm, title: tWithFunction('actions.deleteFunction', 'common.document'), content: tWithFunction('actions.deleteConfirmFunction', 'common.knowledge'), confirmButtonText: translate('actions.confirm'), closeButtonText: translate('actions.cancel'), mode: 'error' }), _jsx(DeleteDocumentDialog, { open: deleteDocumentOpen, isLoading: isMachineLoading, onClose: handleClose, onDelete: handleDelete, options: machinesByDocument, onSelectionChange: setSelectedMachinesForDeletion })] }));
};
export default Knowledge;
